'use client'
import ErrorComponent from 'next/error'
import {
  Component,
  ErrorInfo,
  PropsWithChildren,
  ReactNode,
} from 'react'

type ErrorRegionProps = PropsWithChildren<{
  fallback?: ReactNode
}>

class ErrorRegion extends Component<ErrorRegionProps, { error: Error | null }> {
  constructor(props: ErrorRegionProps) {
    super(props)
    this.state = { error: null }
  }
  static getDerivedStateFromError(error: Error) {
    return { error }
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error({ error, errorInfo })
    this.setState({ error })
  }
  render() {
    if (this.state.error) {
      return this.props.fallback !== undefined ? (
        this.props.fallback
      ) : (
        <ErrorComponent
          statusCode={500}
          withDarkMode={false}
          // TODO: replace this with generic error message once error logging is set up
          title={this.state.error.message}
        />
      )
    }

    return this.props.children
  }
}

export default ErrorRegion
